module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"chart":"График","chart-type:type-1":"Linear","chart-type:type-2":"Bar","chart-type:type-3":"Bar-X","chart-type:type-4":"Pie","chart-type:type-5":"Bar stack","chart-type:type-6":"Bar"},"en":{"chart":"Chart","chart-type:type-1":"Linear","chart-type:type-2":"Bar","chart-type:type-3":"Bar-X","chart-type:type-4":"Pie","chart-type:type-5":"Bar stack","chart-type:type-6":"Bar"}}')
  delete Component.options._Ctor
}
